import { createTheme } from '@mui/material/styles';

const BaseTheme = createTheme({
  palette: {
    primary: {
      main: '#005581',
      light: '#4298B5',
      dark: '#003B5C',
    },
    secondary: {
      main: '#F4AA00',
      light: '#D0BC81',
      dark: '#c56d00',
      contrastText: '#003B5C',
    },
    success: {
      main: '#A6B72F',
      light: '#BFD049',
      dark: '#8bb72f',
      contrastText: '#003B5C',
    },
    grayscale: {
      darkest: '#000',
      "50": "#FAFAFA",
      "100": "#F1F1F1",
      "300": "#D7D7D7",
      "600": "#6B6B6B",
      "900": "#19191D",
      lightest: '#fff',
    },
    bluescale: {
      lightest: "#D9EAF0"
    },
    social: {
      twitterColor: '#1da1f2',
      facebookColor: '#1877f2',
      googleColor: '#ea4335',
      linkedInColor: '#0077b5',
      pinterestColor: '#e60023',
      youtubeColor: '#ff0000',
      tumblrColor: '#35465c',
      behanceColor: '#1769ff',
      dribbbleColor: '#444444',
      redditColor: '#ff4500',
      instagramColor: '#405de6',
      githubColor: '#4078c0',
    },
  },
  typography: {
    fontFamily: `"source sans pro", Arial, sans-serif, "Segoe UI"`,
    fontFamilySlab: `"Roboto Slab", Georgia, serif, "Segoe UI"`,
  }
});

export default BaseTheme;
